import { createStyles } from "@material-ui/core";

export default createStyles({

  chartContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }

});